/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const getConfig = () => ({
 sitecoreApiKey: process.env.SITECORE_API_KEY || 'no-api-key-set',
 sitecoreApiHost: process.env.SITECORE_API_HOST || 'http://njord-store-cm',
 sitecoreSiteName: process.env.SITECORE_SITE_NAME || 'njord-store',
 sitecoreApiKeySupport: process.env.SITECORE_API_KEY_SUPPORT || 'no-api-key-set',
 sitecoreApiHostSupport: process.env.SITECORE_API_HOST_SUPPORT || 'undefined',
 sitecoreSiteNameSupport: process.env.SITECORE_SITE_NAME_SUPPORT || 'njord-support',
 graphQLEndpointPath: process.env.GRAPH_QL_ENDPOINT_PATH || '/sitecore/api/graph/edge',
 defaultLanguage: process.env.DEFAULT_LANGUAGE || 'en',
 graphQLEndpoint: process.env.GRAPH_QL_ENDPOINT || 'http://njord-store-cm/sitecore/api/graph/edge',
 layoutServiceConfigurationName: process.env.LAYOUT_SERVICE_CONFIGURATION_NAME || 'default',
 publicUrl: process.env.PUBLIC_URL || 'http://localhost:3000',
 googleRecaptchaV3SiteKey: process.env.GOOGLE_RECAPTCHA_V3_SITE_KEY || 'undefined',
});
module.exports = getConfig;